interface SectionHeadProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
  accent?: boolean;
}

export default function SectionHead({ eyebrow, title, desc, align = 'left', accent = false }: SectionHeadProps) {
  return (
    <div className={align === 'center' ? 'flex flex-col items-center text-center' : 'flex flex-col'}>
      <span
        className={`inline-flex items-center gap-2 font-label text-xs md:text-sm font-semibold tracking-[0.2em] uppercase ${
          accent ? 'text-accent-700' : 'text-primary-600'
        }`}
      >
        <i className="ri-record-circle-line w-3 h-3 md:w-3.5 md:h-3.5 flex items-center justify-center" />
        {eyebrow}
      </span>
      <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold leading-tight text-foreground-950">
        {title}
      </h2>
      {desc && (
        <p className="mt-3 max-w-2xl text-sm md:text-base leading-relaxed text-foreground-600">
          {desc}
        </p>
      )}
    </div>
  );
}